import { Realm } from '../../../../services/i18nService';

export default class Order {
  suborderId: string;
  creationDateIsoString: string;
  orderId: string;

  constructor(suborderId: string, creationDate: string, orderId: string) {
    this.suborderId = suborderId;
    this.creationDateIsoString = creationDate;
    this.orderId = orderId;
  }
}

export class OrderArticle {
  id?: number;
  name?: string;
  pictureUrl?: string;
  valid: boolean = true;
  loaded: boolean = false;

  constructor(id?: number, name?: string, pictureUrl?: string, loaded: boolean = false) {
    this.id = id;
    this.name = name;
    this.pictureUrl = pictureUrl;
    this.loaded = loaded;
  }
}

export class OrderSellerData {
  sellerName: string;
  orderType: string;

  constructor(sellerName: string, orderType: string) {
    this.sellerName = sellerName;
    this.orderType = orderType;
  }

  get is1POrder(): boolean {
    return this.orderType?.startsWith('1P');
  }

  static create1PForRealm(realm: Realm): OrderSellerData {
    return new OrderSellerData(realm, '1P');
  }
}
